import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkout-section" }
const _hoisted_2 = { class: "checkout-content" }
const _hoisted_3 = { class: "configuration-summary" }
const _hoisted_4 = { class: "config-details" }
const _hoisted_5 = { class: "config-item" }
const _hoisted_6 = { class: "config-value" }
const _hoisted_7 = { class: "config-item" }
const _hoisted_8 = { class: "config-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[4] || (_cache[4] = _createElementVNode("h2", null, "CHECKOUT", -1)),
    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "header-divider" }, null, -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[3] || (_cache[3] = _createElementVNode("div", { class: "config-item" }, [
            _createElementVNode("span", { class: "config-label" }, "Item"),
            _createElementVNode("span", { class: "config-value" }, "Black Tube Screamer")
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("span", { class: "config-label" }, "Knob Color", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.configurationData.knobColor), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "config-label" }, "LED", -1)),
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.configurationData.ledColor), 1)
          ])
        ])
      ]),
      _createElementVNode("button", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleAddToCart && _ctx.handleAddToCart(...args))),
        class: "checkout-button"
      }, " Add to Cart ")
    ])
  ]))
}